export default {
  root: {
    class: [
      // Sizing and Shape
      'min-w-[9rem] max-w-36',
      'rounded-xs',
      // Spacing
      'py-2',
      // Colors
      'bg-white dark:bg-surface-700',
      'border border-gray-400 dark:border-surface-700',

      'shadow-md'
    ]
  },
  menu: {
    class: [
      // Spacings and Shape
      'list-none',
      'm-0',
      'p-0',
      'outline-none'
    ]
  },
  content: ({ context }) => ({
    class: [
      //Shape
      'rounded-none',
      // Colors
      {
        'bg-surface-300': context.focused
      },
      // Transitions
      'transition-shadow',
      'duration-200',
      // States
      'hover:ring-0 hover:bg-surface-300 dark:bg-surface-700 dark:hover:bg-surface-400/10'
    ]
  }),
  action: {
    class: [
      'relative',
      'text-md',
      // Flexbox

      'flex',
      'items-center',

      // Spacing
      'py-2',
      'px-3',

      // Misc
      'no-underline',
      'overflow-hidden',
      'cursor-pointer',
      'select-none'
    ]
  },
  icon: {
    class: [
      // Spacing
      'mr-2',

      // Color
      'text-surface-600 dark:text-white/70'
    ]
  },
  label: {
    class: ['leading-5 text-md']
  },
  submenuheader: {
    class: [
      // Font
      'font-bold',
      // Spacing
      'm-0',
      'py-3 px-5',
      // Shape
      'rounded-tl-none',
      'rounded-tr-none',
      // Colors
      'bg-surface-0 dark:bg-surface-700',
      'text-surface-700 dark:text-white'
    ]
  },
  transition: {
    enterFromClass: 'opacity-0 scale-y-[0.8]',
    enterActiveClass:
      'transition-[transform,opacity] duration-[120ms] ease-[cubic-bezier(0,0,0.2,1)]',
    leaveActiveClass: 'transition-opacity duration-100 ease-linear',
    leaveToClass: 'opacity-0'
  }
}
